module.exports = __webpack_public_path__ + "static/media/comments-alt.aa45e75b.svg";